// extracted by mini-css-extract-plugin
export default {"wrapper":"ProjectEditPage_wrapper__c0rpm"};